import { useAuth } from '@/lib/auth';
import Modal from 'react-bootstrap/Modal';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import './css/PetProfile.scss'
import { SimpleHeader } from './SimpleHeader';
import Close from '@/assets/img/close.svg';
import Utils from '@/utils/util';
import { Order } from '../types';
import { Button } from '@/components/Elements';
import { useRetryPayment } from '../api/retryPayment';
import { useState } from 'react';
import Table from 'react-bootstrap/Table';
import PAYMENT_TYPES from '@/config/constants';
import { useTranslation } from 'react-i18next';
type Props = {
  // onSuccess: () => void;
  // onBackClick?: () => void;
  // isOpen: boolean;
  transactions?: Order[];
  onRefetch?: () => void;
}
export const TransactionList = ({ transactions, onRefetch }: Props) => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [disableUI, setDisableUI] = useState(false);
  const retryPaymentMutation = useRetryPayment();
  
  const getPaymentStatus = (item: Order) => {
    if (PAYMENT_TYPES.FAILURE.indexOf(item.paymentStatus || '') >= 0) {
      return t("Failure");
    }
    
    if (PAYMENT_TYPES.SUCCESS.indexOf(item.paymentStatus || '') >= 0) {
      return t("Success");
    }
    
    return t("Pending");
  }

  const getPaymentAmmount = (item: Order) => {
    if (item?.refundMetaData?.percentage) {
      const amt = (Number(item?.refundMetaData?.percentage) * Number(item.paymentAmount)) / 100;
      return `$${Number(item.paymentAmount).toFixed(2)} (${(Number(item?.refundMetaData?.percentage) >= 100
        ? `${t('Refunded')} $${Number(amt).toFixed(2)}`
        : `${t('Partial Refunded')} $${Number(amt).toFixed(2)}`)})`;
    }

    return `$${Number(item.paymentAmount).toFixed(2)}`;
  };

  return (
    <>
      <Table responsive="sm" className="table-auto w-full mt-4 responsive-table">
                <thead>
                  <tr>
                    <th className='p-2'>{t('ID')}</th>
                    <th className='p-2'>{t('Date')}</th>
                    <th className='p-2'>{t('Amount')}</th>
                    <th className='p-2'>{t('Status')}</th>
                    <th className='p-2'>{t('Provider')}</th>
                    <th className='p-2'></th>
                  </tr>
                </thead>
                <tbody>
                  {transactions?.map(trx => <tr>
                    <td className='p-2'>#{trx.id}</td>
                    <td className='p-2'>{trx.paymentDate ? `${Utils.getOnlyDate(trx.paymentDate)} ${Utils.getAMPMtimeWithoutFormat(trx.paymentDate)}` : "-"}</td>
                    <td className='p-2'>{getPaymentAmmount(trx)}</td>
                    <td className='p-2'>{getPaymentStatus(trx)}</td>
                    <td className='p-2'>{trx.paymentProvider}</td>
                    <td className='p-2'>
                      {
                        !trx.isRetrySuccessful && getPaymentStatus(trx) === t("Failure") ? 
                          <Button disabled={disableUI} variant='inverse' onClick={async (ev: any) => {
                            ev.preventDefault();
                            
                            if (disableUI) {
                              return;
                            }

                            setDisableUI(true);
                            await retryPaymentMutation.mutateAsync({ orderId: trx.id });
                            setDisableUI(false);
                            onRefetch && onRefetch();
                          }}>{t('Retry Payment')}</Button> : 
                          (getPaymentStatus(trx) === t("Pending") && trx.paymentLink ? <a href={trx.paymentLink} target="_blank" className="text-blue-600 hover:text-blue-900" rel="noreferrer">Pay Now</a> : null)
                      }
                    </td>
                  </tr>)}
                </tbody>
              </Table>
      </>
  );
};
